<div class="list-header__breadcrumbs" *ngIf="!p.renderMobile">
  <app-breadcrumb></app-breadcrumb>
</div>
<div class="list-header__filter-outher-container">
  <ng-content select="[top]"></ng-content>

  <div
    *ngIf="!hideSeparator && !p.renderMobile"
    class="list-header__separator"
  ></div>

  <ng-content select="[bottom]"></ng-content>
</div>
<div
  class="list-header__filter-button"
  *ngIf="p.renderMobile && !hideHeader"
  [ngStyle]="{ 'max-width.px': mobileWidth }"
>
  <ion-label
    class="list-header__filter-label"
    [ngClass]="{
      'list-header__filter-label--absolute-position': absoluteFilterButton
    }"
    (click)="onToggleFilter()"
  >
    {{ "FILTER" | translate }}
  </ion-label>
</div>
